<template>
    <div class="login">
        <div class="panel" v-if="!loading">
            <h2>Demo Login</h2>
            <input type="email" v-model="email" placeholder="Email" required autofocus />
            <input type="password" v-model="password" placeholder="Password" @keyup.enter="login" required />
            <div class="confirm">
                <button type="button" @click="login">Login</button>
            </div>
        </div>
        <div class="panel" v-else>
            <b-spinner type="grow"></b-spinner>
        </div>
        <div v-if="error && !loading" class="alert alert-danger" role="alert">
            {{ error }}
        </div>
    </div>
</template>

<script>

import VueJwtDecode from 'vue-jwt-decode'

import config from '../config';

export default {
    data() {
        return {
            email: '',
            password: '',
            loading: false,
            error: null
        }
    },
    methods: {
        login() {
            this.loading = true;
            
            fetch(`${config.api}/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', },
                body: JSON.stringify({
                    email: this.email,
                    password: this.password
                })
            })
            .then(response => response.json())
            .then(data => {
                const token = data.token;

                const decoded = VueJwtDecode.decode(token);
                
                localStorage.setItem('token', token);
                localStorage.setItem('payload', JSON.stringify(decoded));

                this.$router.push('/' + decoded.app_id)

            })
            .catch((error) => {
                this.error = 'Invalid login information';
            })
            .finally(() => {
                this.loading = false;
            });
        }
    },
    mounted() {
        localStorage.removeItem('token');
        localStorage.removeItem('payload');
    }
}
</script>

<style scoped>

h2 {
    margin-bottom: 20px;
    font-size: 24px;
}

.login {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;
}

.panel {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

h1 {
  margin-bottom: 20px;
}

input {
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 10px;
    width: 300px;
    font-size: 12px;

    background-color: #fafafa;
    border-radius: 5px;

    border: none;
    outline: none;
}

button {
  padding: 10px 20px;
  background-color: #8447ff;
  color: white;
  border: none;
  cursor: pointer;
  transition: 200ms;
  border-radius: 5px;
}
.confirm {
    margin-bottom: 20px;
}

.login button:hover {
    background-color: #6018f0;
    transition: 200ms;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue